import React from 'react';
import Belgium from './belgium.inline.svg';
import { ParcoursTile } from './tile';

export class Parcours extends React.Component {
  state = {
    activeStop: 0,
    activeTile: 0
  }

  componentDidMount () {
    this.buttons = [
      this.refs.map.querySelector('#map1'),
      this.refs.map.querySelector('#map2'),
      this.refs.map.querySelector('#map3'),
      this.refs.map.querySelector('#map4'),
      this.refs.map.querySelector('#map5'),
      this.refs.map.querySelector('#map6'),
      this.refs.map.querySelector('#map7'),
      this.refs.map.querySelector('#map8'),
    ]

    this.buttons.forEach((button, index) => {
      button.addEventListener('mouseover', () => this.hover(index, -1));
    });
  }

  hover = (activeStop, activeTile) => {
    if (activeTile == -1) {
      activeTile = this.props.items.findIndex(item => activeStop === item.numberOnTheMap - 1);
      const node = this.refs.tiles.childNodes[activeTile];
    }

    this.buttons.forEach(button => button.classList.remove('active'));
    this.buttons[activeStop].classList.add('active');
    this.setState({ activeStop, activeTile });
  }

  render () {
    const { activeStop, activeTile } = this.state;
    const { items } = this.props;
    const activeItem = items[activeTile];

    return (
      <section className="parcours container">
        <div className="parcours__map" ref="map">
          <Belgium />
        </div>
        <div className="parcours__content">
          <div className="parcours__content__image">
            <img src={activeItem.image?.file?.url + '?w=400&h=400&fit=fill'} />
          </div>
          <div className="parcours__content__tiles" ref="tiles">
            { items.map((item, index) => (
              <ParcoursTile
                {...item}
                index={index}
                key={item.id}
                onHover={this.hover}
                active={item === activeItem}
              />)) }
          </div>
        </div>
      </section>
    )
  }
}